import React, { useState } from 'react'
import logo from '../../assets/images/svgs/flexgrade.svg';
import PrimaryBtn from '../buttons/primaryBtn';
import blueLogo from '../../assets/images/svgs/flexgradeBlue.svg';
import './style.scss';
import ApplyForm from '../../pages/home/partials/applyForm';

const MarketingNavbar = ({ blue, isAbsolute }) => {

  const [modalShow, setModalShow] = useState(false);

  const openModal = () => setModalShow(true);

  return (
    <>
      <div className={`marketing__navbar__main ${isAbsolute && 'position__absolute'} ${blue ? "blue__border" :""}`}>
        <div className='nav__sections custom__container d-flex align-items-center justify-content-between'>
          <div>
            <img src={blue ? blueLogo : logo} alt='logo' />
          </div>
          <div>
            <PrimaryBtn classes='apply__btn' onClick={openModal} small text={"Apply"} />
          </div>
        </div>
      </div>
      <ApplyForm
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  )
}

export default MarketingNavbar